module.exports = __webpack_public_path__ + "img/icon3@3x.c6f106f8.png";